var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collection-c", on: { click: _vm.clickCollection } },
    [
      _c("div", { staticClass: "icon" }, [
        _c("div", {
          class: [_vm.isCollection ? "collection-icon" : "no-collection-icon"],
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "count" }, [
        _vm._v(_vm._s(_vm.setCount(_vm.collectionCount))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }